export const Level = {
    name: 'Level',
    value: 'LEVEL',
};
export const BusinessEntity = {
    name: 'Business Entity',
    value: 'BUSINESS_ENTITY',
};
export const Campus = {
    name: 'Campus',
    value: 'CAMPUS',
};
const All = [Level, BusinessEntity, Campus];
const ByValue = All.reduce((hash, type) => {
    hash[type.value] = type;
    return hash;
}, {});
export function isBusinessEntity(org) {
    return (org === null || org === void 0 ? void 0 : org.organisationType) === BusinessEntity.value;
}
export function isLevel(org) {
    return (org === null || org === void 0 ? void 0 : org.organisationType) === Level.value;
}
export function isCampus(org) {
    return org.organisationType === Campus.value;
}
export default {
    All,
    ByValue,
    Level,
    BusinessEntity,
    Campus,
    isLevel,
    isBusinessEntity,
    isCampus,
};
